import { lazy, Suspense } from "react";

// Batch 19 S8d: the external defect portal is its own shell in the same SPA (SA-B19-EVENTS §4.1), loaded only when visited.
const PortalRoot = lazy(() => import("../features/portal/PortalApp").then((module) => ({ default: module.PortalRoot })));
const PortalLoginPage = lazy(() => import("../features/portal/PortalLogin").then((module) => ({ default: module.PortalLoginPage })));

function Waiting() {
  return <div className="gf-startup" role="status" aria-busy="true" />;
}

/** `/portal/*`: the external tester's portal, never inside AppShell. */
export function PortalEntry() {
  return (
    <Suspense fallback={<Waiting />}>
      <PortalRoot />
    </Suspense>
  );
}

/** `/portal/login`: the portal's sign-in page. */
export function PortalLoginEntry() {
  return (
    <Suspense fallback={<Waiting />}>
      <PortalLoginPage />
    </Suspense>
  );
}
